import styled, { css } from 'styled-components'

export type ContainerProps = {
  $fluid?: boolean
}

const Container = styled.div.attrs<ContainerProps>(({ $fluid }) => ({
  className: `container${$fluid ? '-fluid' : ''} grid`
}))<ContainerProps>`
  ${({ $fluid }) =>
    $fluid
      ? css`
          padding-left: 100px;
          padding-right: 100px;
        `
      : ''}
`

export default Container
